import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InfoFilledIcon from "@mui/icons-material/Info";
import {InfoIconProps} from "./types";

const InfoIcon = ({
  variant,
  color = "primary",
  sx = {}
}: InfoIconProps) => {
  
  if (variant === "outlined") {
    return (
      <InfoOutlinedIcon
        color={color}
        sx={sx}
      />
    );
  }

  if (variant === "filled") {
    return (
      <InfoFilledIcon
        color={color}
        sx={sx}
      />
    );
  }
  
  return null;
};

export default InfoIcon;